module.exports = __webpack_public_path__ + "static/media/ic_hi_b5_fisdom.2e278982.svg";